import { getWindowsHeight } from './generic';

// prepocita rozmery backdrop elementu (pri zmene velikosti okna modalu)
export const modalBackdropResize = (): void => {
    const windowHeight = getWindowsHeight();
    const modalElements = document.getElementsByClassName('modal-dialog');
    if (modalElements && modalElements[0]) {
        const modalHeight = modalElements[0].clientHeight + 60;
        const height = windowHeight > modalHeight ? windowHeight : modalHeight;
        const backdropEls = document.getElementsByClassName('modal-backdrop');
        if (backdropEls && backdropEls[0]) {
            (backdropEls[0] as HTMLDivElement).style.height = `${height}px`;
        }
    }
};
